var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "app-main-inner edi-bill-search-selector",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t("SeaExport.CopyFromOtherBill"),
            width: "1000px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            },
            close: function($event) {
              return _vm.cancel()
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "app-main-inner-row" },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_BusinessNo") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "260px" },
                        attrs: { no: "1" },
                        model: {
                          value: _vm.jobNo,
                          callback: function($$v) {
                            _vm.jobNo = $$v
                          },
                          expression: "jobNo"
                        }
                      }),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "30px" },
                          attrs: { type: "primary", no: "2" },
                          on: { click: _vm.searchHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                      )
                    ],
                    1
                  ),
                  _c("el-form-item")
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row row-grid",
              staticStyle: { "min-height": "350px", padding: "0" }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%", height: "350px" },
                attrs: {
                  "config-module": "130202",
                  "grid-params": _vm.gridParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDef,
                  "row-data": _vm.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  },
                  gridReady: function(params) {
                    return (_vm.gridApi = params.api)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "app-main-inner-row row-pagination" },
            [
              _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchConditions.total > 0,
                    expression: "searchConditions.total>0"
                  }
                ],
                attrs: {
                  total: _vm.searchConditions.total,
                  page: _vm.searchConditions.pageNum,
                  limit: _vm.searchConditions.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageSize", $event)
                  },
                  pagination: _vm.searchHandler
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "3" },
                  on: { click: _vm.confirm }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                { attrs: { no: "4" }, on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }